export default "__VITE_ASSET__ioh2K5CF__"